import { fromJS, List, Map } from 'immutable';
import * as actionTypes from './actionTypes';
import { createReducer } from 'utils/redux';

const initialState = new Map({
  data: List(),
  loading: false,
  error: null,
});

const onGetDeductionBalance = (state) => state.set('loading', true).set('error', null);

const onGetDeductionBalanceSuccess = (state, { payload }) =>
  state.set('loading', false).set('data', fromJS(payload));

const onGetDeductionBalanceError = (state, { payload }) =>
  state.set('loading', false).set('error', payload);

export default createReducer(initialState, {
  [actionTypes.GET_PROPERTY_DEDUCTIONS_BALANCE]: onGetDeductionBalance,
  [actionTypes.GET_PROPERTY_DEDUCTIONS_BALANCE_SUCCESS]: onGetDeductionBalanceSuccess,
  [actionTypes.GET_PROPERTY_DEDUCTIONS_BALANCE_FAILURE]: onGetDeductionBalanceError,
});
